// SPDX-License-Identifier: Apache-2.0
export const DEFAULT_OPACITY = 0;
export const OPACITY_FOR_DEFAULT_BASEMAP = 1;
